export interface CarrierChangeReasonOption {
  value: string;
  label: string;
}

/**
 * Predefined Linehaul carrier-change reasons (Story 3).
 * Use these constants until GET /carrier-change-reasons is available.
 */
export const CARRIER_CHANGE_REASONS: CarrierChangeReasonOption[] = [
  { value: "CARRIER_CANCELLATION", label: "Carrier Cancellation" },
  { value: "DRIVER_UNAVAILABLE", label: "Driver Unavailable" },
  { value: "EQUIPMENT_UNAVAILABLE", label: "Equipment Unavailable" },
  { value: "INSUFFICIENT_FREIGHT_VOLUME", label: "Insufficient Freight Volume" },
  { value: "NETWORK_COST_OPTIMIZATION", label: "Network / Cost Optimization" },
];

export const getCarrierChangeReasonLabel = (code?: string | null): string =>
  CARRIER_CHANGE_REASONS.find((reason) => reason.value === code)?.label ?? "";
